import WithRender from "../../templates/tables/uploadTable.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getShowUpload"]),
    name: () => {
      return "Upload";
    }
  },
  props: ["alwaysShow"]
});
